import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Observable, debounceTime, filter, map, of, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { StripListHeaderComponent } from '@shared/components/strip-list/strip-list-header/strip-list-header.component';
import { StripListItemComponent } from '@shared/components/strip-list/strip-list-item/strip-list-item.component';
import { BasedComponent } from '@shared/components/based.component';
import { Terminal } from '@app/shared/classes/terminal';
import { ToggleButtonComponent, ToggleButtonType } from '@shared/components/toggle-button';
import { GetOrgTerminalList } from '@app/shared/actions/common-data.action';
import { Select, Store } from '@ngxs/store';
import { AppDataState } from '@app/shared/stores/app-data.state';
import { NgxsActionName } from '@app/shared/constants';
import { WebApiResponse } from '@app/shared/classes/general';
import { LoadingSpinnerComponent } from '@shared/components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-terminal-search-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    StripListHeaderComponent,
    StripListItemComponent,
    ToggleButtonComponent,
    LoadingSpinnerComponent
  ],
  templateUrl: './terminal-search-grid.component.html',
  styleUrl: './terminal-search-grid.component.css'
})
export class TerminalSearchGridComponent extends BasedComponent {
  store = inject(Store);

  @Input() filterText$: Observable<string> = of('');
  @Output() itemToggled = new EventEmitter();

  ToggleButtonType = ToggleButtonType;
  selected: Terminal;
  dataSource$: Observable<Terminal[]>;

  @Select(AppDataState.taskResponse(NgxsActionName.GET_ORG_TERMINAL_LIST)) terminalDataResponse$: Observable<WebApiResponse<Terminal[]>>;
  @Select(AppDataState.taskExecuting(NgxsActionName.GET_ORG_TERMINAL_LIST)) processing$: Observable<boolean>;

  constructor() {
    super();
  }

  override ngOnInit(): void {
    this.dataSource$ = this.terminalDataResponse$.pipe(filter(res => res !== undefined), map(res => res.data));
    this.filterText$.pipe(debounceTime(400), takeUntil(this.destroy$)).subscribe(filterText => {
      if (filterText) {
        this.selected = null;
      }

      if (filterText.length > 3) {
        this.store.dispatch(new GetOrgTerminalList(filterText));
      }
      else {
        this.store.dispatch(new GetOrgTerminalList(''));
      }
    });
  }

  itemSelected = (item: Terminal) => {
    this.selected = item;
    this.itemToggled.emit({ item: item, toggled: true });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
